

import type { OrderType } from "@/types";

import Kanban from "@univdiam/ui/customComponents/Kanban"
import Column from "@univdiam/ui/customComponents/Kanban/Column";
import { useEffect, useState } from "react";
import { kanbanColumns } from "@univdiam/ui/lib/KanbanColumns";

export type ColumnPagination = {
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
}

type KanbanViewProps = {
  data: OrderType[],
  handleOrderOpen: (id: string, customer_id: string) => void
  globalFilter: string;
  columnVisibility: Record<string, boolean>;
  isAdmin?: boolean;
  // Keyed by column id: each column paginates on its own cursor.
  columnPagination?: Record<string, ColumnPagination>;
}

const KanbanView = ({ data, handleOrderOpen, columnVisibility, globalFilter, isAdmin, columnPagination }: KanbanViewProps) => {
  const [cards, setCards] = useState<OrderType[]>([]);


  // useEffect(() => {
  //   if (data) {
  //     console.log("Data received in KanbanView:", data);
  //     const transformed = (data as OrderType[]).map(order => ({
  //       ...order,
  //       column: order.status
  //     }))
  //     setCards(transformed)
  //   }
  // }, [data])


  useEffect(() => {
    if (!data) {
      setCards([]);
      return;
    }

    const filtered = data.filter((order) => {
      if (!globalFilter) return true;

      const filter = globalFilter.toLowerCase().trim();

      return (
        order.order_id?.toLowerCase().includes(filter) ||
        order.job_title?.toLowerCase().includes(filter) ||
        order.product_type?.toLowerCase().includes(filter) ||
        order.metal_type?.toLowerCase().includes(filter) ||
        order.status?.toLowerCase().includes(filter) ||
        order.size?.toLowerCase().includes(filter) ||
        order.customer_id?.toString().includes(filter)
      );
    });

    const transformed = filtered.map(order => ({
      ...order,
      column: order.status // maps to Kanban column
    }));

    setCards(transformed);
  }, [data, globalFilter]);



  return (
    // <div className="min-h-screen w-full p-[24px]">
    <div className="h-full w-full">
      <Kanban>
        {kanbanColumns.map(col => {
          if (!columnVisibility[col.id]) return null; // skip hidden columns
          return (
            <Column
              key={col.id}
              title={col.title}
              column={col.id}
              headingColor={col.headingColor}
              cards={cards}
              setCards={setCards}
              isDrag={false}
              handleOrderOpen={handleOrderOpen}
              isAdmin={isAdmin}
              fetchNextPage={columnPagination?.[col.id]?.fetchNextPage}
              hasNextPage={columnPagination?.[col.id]?.hasNextPage}
              isFetchingNextPage={columnPagination?.[col.id]?.isFetchingNextPage}
            />
          );
        })}
      </Kanban>


    </div>
  )
}

export default KanbanView